module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-1-en-US-bbcb7e3beef8f01c2f24e41ceb920d1c.png";